import { NavLink, useLocation } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import { isTamMonthlyPrimesNavActive } from '../../utils/monthlyPrime.utils';

const PrimesTamNav = () => {
  const { t } = useTranslation(['primes']);
  const { pathname } = useLocation();
  const isMonthlyActive = isTamMonthlyPrimesNavActive(pathname);
  const isAnnualActive = pathname === '/primes/annuel';

  return (
    <NavContainer>
      <NavItem to="/primes/mois" $active={isMonthlyActive}>
        {t('navMonthly')}
      </NavItem>
      <NavItem to="/primes/annuel" $active={isAnnualActive}>
        {t('navAnnual')}
      </NavItem>
    </NavContainer>
  );
};

export default PrimesTamNav;

const NavContainer = styled('nav')(({ theme }) => ({
  display: 'flex',
  gap: theme.spacing(2),
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(1),
}));

const NavItem = styled(NavLink, {
  shouldForwardProp: (prop) => prop !== '$active',
})<{ $active?: boolean }>(({ theme, $active }) => ({
  padding: `${theme.spacing(0.75)} ${theme.spacing(2)}`,
  borderRadius: '8px',
  textDecoration: 'none',
  fontWeight: 600,
  color: theme.palette.neutral[60],
  border: `1px solid ${theme.palette.neutral[20]}`,
  ...($active && {
    color: theme.palette.red[60],
    borderColor: theme.palette.red[40],
    backgroundColor: theme.palette.red[20],
  }),
}));
